import JsonDetails from './JsonDetails';
import TextDetails from './TextDetails';
import { DisplayP2pMethodsDetails } from './DisplayP2pMethodsDetails';
import ArrayDetails from './ArrayDetails';

const Details = {
    Json: JsonDetails,
    TextDetails: TextDetails,
    Array: ArrayDetails,
    DisplayP2pMethods: DisplayP2pMethodsDetails,
};

export default Details;
